<template>
    <div class="py-2">
        <span>Velg format</span>
        <URadioGroup
            v-model="selectedFormat"
            color="primary"
            variant="table"
            size="sm"
            orientation="horizontal"
            :default-value="CsvFormats.CUSTOM"
            :items="items"
        />
    </div>
</template>

<script setup lang="ts">

import {ref} from 'vue'
import {CsvFormats} from '@/csv-transaction-importer/csv-import.service'
type RadioItem = {
    label: string
    value: CsvFormats | string
    description?: string
}

const items = ref<RadioItem[]>([
    {
        label: 'Standard',
        value: CsvFormats.CUSTOM,
        description: 'Manuelt kolonneoppsett',
    },
    {
        label: CsvFormats.VIPPS,
        value: CsvFormats.VIPPS,
    },
    {
        label: CsvFormats.KLARNA,
        value: CsvFormats.KLARNA,
    }
])

const selectedFormat = defineModel<CsvFormats>('modelValue', {default: CsvFormats.CUSTOM})

</script>

<style scoped>

</style>